import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'headScriptInjection',
  initialState: null as string | null,
  reducers: {
    setHeadScriptInjection(state, action: PayloadAction<string | null>) {
      return action.payload || null;
    },
  },
});

export const { setHeadScriptInjection } = slice.actions;

export default slice.reducer;
